import React from "react";

import { Button, Stack, Tooltip, useTheme } from "@mui/material";

export interface ButtonBarButtonProps {
  children?: React.ReactNode;
  disabled?: boolean;
  active?: boolean;
  activeTooltip: string;
  inactiveTooltip?: string;
  activeColor?: string;
  icon?: React.ReactNode;
  tooltipPlacement?: "top" | "bottom" | "left" | "right";
  onClick: () => void;
}

export const ControlPanelButton: React.FC<React.PropsWithChildren<ButtonBarButtonProps>> = ({
  children,
  icon,
  activeTooltip,
  inactiveTooltip,
  disabled = false,
  active = true,
  activeColor,
  tooltipPlacement,
  onClick,
}) => {

  const theme = useTheme();

  const tooltip = disabled
    ? inactiveTooltip || activeTooltip : activeTooltip

  const finalColor = active ? activeColor || theme.palette.primary.light : theme.palette.grey[300]
  const color = disabled ? "#979797" : finalColor

  return (
    <Tooltip title={tooltip} placement={tooltipPlacement}>
      <Stack
        direction="row"
        sx={{
          borderRadius: 1,
          boxShadow: 1,
          backgroundColor: color,
          alignItems: "center",
        }}
      >
        <Button
          disabled={disabled}
          onClick={() => onClick()}
          aria-label={tooltip}
          sx={{
            color: "black",
            lineHeight: 1.4,
            height: "100%",
            width: "100%",
            padding: 1,
          }}
        >
          {icon}
          {children}
        </Button>
      </Stack>
    </Tooltip>
  );
};

export default ControlPanelButton;
